import { render } from "./WeeklyTrucks.vue?vue&type=template&id=6d04fb39&scoped=true"
import script from "./WeeklyTrucks.vue?vue&type=script&lang=js"
export * from "./WeeklyTrucks.vue?vue&type=script&lang=js"

import "./WeeklyTrucks.vue?vue&type=style&index=0&id=6d04fb39&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d04fb39"]])

export default __exports__